import { flashcardRouteDefinitions } from '@features/flashcards/routes'
import { learningRouteDefinitions } from '@features/learning/routes'
import { premiumRouteDefinitions } from '@features/premium/routes'
import { profileRouteDefinitions } from '@features/profile/routes'
import { shortVideoRouteDefinitions } from '@features/short-videos/routes'
import { isLearnerRouteEnabled } from './learner-feature-availability'
import type {
  LearnerRouteDefinition,
  LearnerRouteId,
  LearnerScreenId,
} from './learner-route-types'

const allLearnerRouteDefinitions: readonly LearnerRouteDefinition[] = [
  ...learningRouteDefinitions,
  ...flashcardRouteDefinitions,
  ...shortVideoRouteDefinitions,
  ...profileRouteDefinitions,
  ...premiumRouteDefinitions,
]

export const learnerRouteDefinitions = allLearnerRouteDefinitions.filter((route) =>
  isLearnerRouteEnabled(route.id),
)

export const learnerMainMenuRouteDefinitions = learnerRouteDefinitions.filter(
  (route) => route.showInMainMenu,
)

export function getLearnerRouteById(routeId: LearnerRouteId) {
  return learnerRouteDefinitions.find((route) => route.id === routeId) ?? null
}

export function getLearnerRouteByLegacyScreen(screenId: LearnerScreenId) {
  return learnerRouteDefinitions.find((route) => route.legacyScreen === screenId) ?? null
}

